import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash-es';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import { Observable } from 'rxjs';
@Injectable()
export class TagsModel {
    section: string = '';
    refId: number;
    tagModels: any;
    tags: any;

    constructor(private http: HttpClient) {
        this.http = http;
    }

    format(tags: any = []) {
        var formattedTags = [];

        _.each(tags, function (tag) {
            formattedTags.push({
                text: tag
            });
        });

        return formattedTags;
    }

    toString(tags: any = []) {
        return (_.map(tags, function (tag) { return tag.text })).join(',');
    }

    load(section: string, refId: number) {
        this.section = section;
        this.refId = refId;

        return this.http.get(`/api/tag/${section}/${refId}`)
            .toPromise()
            .then((response) => {
                //Iterate and convert tag objects into a string
                var arr_tags = [];

                this.tagModels = response;

                _.each(this.tagModels.items, function (tag, key) {
                    arr_tags.push(tag.tagName);
                });
                this.tags = arr_tags;

                // Return the loaded tags so callers can use this result directly instead of
                // reading the shared this.tags field, which is unsafe when multiple components
                // (e.g. several gf-tags-display instances) share this singleton model.
                return { success: true, tags: arr_tags };
            })
            .catch(() => {
                return { success: false, tags: [] };
            })

    }

    save(section: string = '', refId: number = 0, strTags: string = '') {
        return this.http.put(`/api/tag/${section}/${refId}`, { tags: strTags })
            .toPromise();
    }
}
